import { API_V1 } from 'API/APIs/APIv1';
import { SearchTypes } from 'features/linkedin-crawler/linkedin-profile-finder/linkedin-profile-finder.types';
import { LinkedinTypes } from 'enums';
import _ from 'lodash';
import Logger from 'logger';

export const getLinkedinSearchProjectById = async (projectId: string, signal?: any) => {
  try {
    const response = await API_V1.get(`/linkedinsearchproject/${projectId}`, {
      signal,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while fetching a single LinkedIn search project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const createLinkedinSearchProject = async (
  name: string,
  searchKeywords: string[],
  product?: LinkedinTypes,
  searchType?: SearchTypes
) => {
  try {
    const response = await API_V1.post('/linkedinsearchproject', {
      name,
      searchKeywords,
      product,
      searchType,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while creating a LinkedIn search project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const startLinkedinSearch = async (projectId: string, liAtCookie: string, sessionCookie: string, seatCookie?: string) => {
  try {
    const response = await API_V1.post(`/linkedinsearchproject/${projectId}/startSearch`, {
      liAtCookie: liAtCookie ? liAtCookie : undefined,
      sessionCookie: sessionCookie ? sessionCookie : undefined,
      seatCookie: seatCookie ? seatCookie : undefined,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while searching for LinkedIn contacts!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const getLinkedinUrlSearchResults = async (projectId: string) => {
  try {
    const response = await API_V1.get(`/linkedinsearchproject/${projectId}/getResults`);

    return response.data;
  } catch (e) {
    Logger.trace('Error while fetching LinkedIn search results!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};
